import React, { useState } from "react";
import UserMenu from "../header/UserMenu";
import { Link, useLocation, useNavigate } from "react-router-dom";
import RequestMenu from "../RequestMenu";
import { menuLinks } from "./constant";
import { useSelector } from "react-redux";
import { getImageBaseUrl } from "../../services/s3-utils";
import OtherMenu from "../header/OtherMenu";
import { useLogout } from "../../hooks/useLogout";

export const RightHeaderComponent = ({ className, mentor }) => {
  const qalortUser = useSelector((state) => state.user.userData);
  const location = useLocation();

  return (
    <>
      {qalortUser ? (
        <div className={`flex gap-2.5 lg:gap-4 items-center ${className}`}>
          {/* <OtherMenu /> */}
          {mentor ? (
            <Link to="/dashboard">
              <button className="view-mentors md:flex gap-[17px] bw-1 bg-white text-tint p-xs py-1 px-2 sm:px-3 flex items-center rounded-md border-pri">
                View Dashboard
                <img
                  src={`${getImageBaseUrl}/assets/caret-right.svg`}
                  alt=""
                  className="hidden sm:block"
                />
              </button>
            </Link>
          ) : qalortUser?.user_type !== "instructor" ? (
            <Link to="/mentors">
              <button className="view-mentors md:flex gap-[17px] bw-1 bg-white text-tint p-xs py-1 px-2 sm:px-3 flex items-center rounded-md border-pri">
                View Mentors
                <img
                  src={`${getImageBaseUrl}/assets/caret-right.svg`}
                  alt=""
                  className="hidden sm:block"
                />
              </button>
            </Link>
          ) : null}

          <RequestMenu hideDot={false}>
            <img
              src={`${getImageBaseUrl}/assets/notification.svg`}
              className="w-6 h-[24px] notification"
              alt=""
            />
          </RequestMenu>
          <UserMenu />
        </div>
      ) : (
        <div className="flex [@media(max-width:900px)]:hidden">
          {location.pathname !== "/signup" && (
            <Link to="/signup">
              <button className="ml-4 bg-pri bg-white text-white text-xs py-2 px-4 mr-2 flex items-center rounded-md border-pri">
                Sign Up
              </button>
            </Link>
          )}
          <Link to="/login">
            <button className="ml-4 bg-pri-tint-3 bw-1 bg-white text-tint text-xs py-2 px-4 flex items-center rounded-md border-pri">
              Login
            </button>
          </Link>
        </div>
      )}
    </>
  );
};

function Header({ mentor }) {
  const [openSideMobile, setOpenSideMobile] = useState(false);
  const qalortUser = useSelector((state) => state.user.userData);
  const navigate = useNavigate();
  const logoutHandler = useLogout();

  const logout = () => {
    logoutHandler();
  };

  return (
    <>
      <div
        id="app_header"
        className="bg-white app-container py-4 sticky top-0 left-0 w-full z-50 border-b-1 border-grey-2"
      >
        <div className="flex justify-between items-center app-container-section">
          <Link to="/">
            <span className="flex">
              <img
                src={`${getImageBaseUrl}/assets/logo.svg`}
                className="w-[103px] h-8"
                alt=""
              />
            </span>
          </Link>
          <div>
            <RightHeaderComponent
              className="[@media(max-width:900px)]:hidden"
              mentor={mentor}
            />
            <button
              className={`w-6 h-6 relative [@media(max-width:900px)]:block hidden ${
                openSideMobile ? "hamburger" : ""
              }`}
              onClick={() => setOpenSideMobile(!openSideMobile)}
            >
              <div className="bg-dark-2 w-6 h-0.5 rounded absolute top-4 -mt-0.5 transition-all duration-100 before:content-[''] before:bg-[#7575A8] before:w-6 before:h-0.5 before:rounded before:absolute before:-translate-x-3 before:-translate-y-[7px] before:transition-all before:duration-500 after:content-[''] after:bg-[#7575A8] after:w-6 after:h-0.5 after:rounded after:absolute after:-translate-x-3 after:translate-y-[7px] after:transition-all after:duration-500"></div>
            </button>
          </div>
        </div>
      </div>

      {qalortUser ? (
        <div
          className={`flex flex-col gap-6 bg-white pt-5 pl-5 fixed min-h-screen w-full opacity-0 z-20 right-0 text-main text-xl leading-10 ${
            openSideMobile ? "opacity-100 left-0" : "hidden"
          }`}
        >
          {menuLinks.map((link, i) => (
            <div
              key={i}
              onClick={() => {
                navigate(link.link);
              }}
            >
              {link.text}
            </div>
          ))}
          <div onClick={logout}>Logout</div>
        </div>
      ) : (
        <div
          className={`flex flex-col gap-6 bg-white pt-5 pl-5 fixed min-h-screen w-full opacity-0 z-20 right-0 ${
            openSideMobile ? "opacity-100 left-0" : "hidden"
          }`}
        >
          <Link to="/signup" className="text-main text-xl leading-10">
            Sign Up
          </Link>
          <Link to="/login" className="text-main text-xl leading-10">
            Login
          </Link>
        </div>
      )}
    </>
  );
}

export default Header;
